<script>
import appConfig from "@/app.config";
import ItemsApi from "@/services/items-api";
import BlockItemsApi from "@/services/items-block-api";
import Swal from "sweetalert2";
import i18n from "../i18n";
import Vue from 'vue'

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}

export default {
    page: {
        title: "Liste Noire des articles",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { },
    computed: {
        role() {
        return this.$cookies.get('userr');
        },

        permission() {
            const  storedPermissions = JSON.parse(getCookie('permission')) || [];
            return storedPermissions
        },
    },
    mounted(){
        this.findBlackListItems()
        this.findItems()

    },
    
    data() {
        return {
            itemsList:[],
            itemsBlackList:[],
            isBlackListTableLoading:false,
            isTableLoading:false,
            isAdmin: true,
            reference:null,
            itemsListFields : [
                { key:"ref", thClass:"text-left", tdClass:"text-left font-weight-bold align-middle", },
                { key:"title", thClass:"text-left ", tdClass:"text-left align-middle font-weight-bold no-wrap", thStyle:"min-width:30%;"},
                { key:"action", label:"", thStyle:"width:30%;", tdClass:"align-middle text-right"},
            ],

            blockedItemsListFields : [
                { key:"creationDate", label:"Date", thClass:"text-left", tdClass:"text-left text-danger font-weight-bold align-middle", },
                { key:"ref", thClass:"text-left", tdClass:"text-left font-weight-bold align-middle", },
                { key:"title", thClass:"text-left ", tdClass:"text-left align-middle font-weight-bold no-wrap", thStyle:"min-width:30%;"},
                { key:"action", label:"", thStyle:"width:30%;", tdClass:"align-middle text-right"},
            ],

            pagemodel: {currentPage : 1, perPage : 5, totalRows: 0},
            pagemodelBlack: {currentPage : 1, perPage : 5, totalRows: 0},
            selectedBrandsList:[],
            newItems: null,
            searchInNewItemsOnly: false,
            searchInNewItemsLast24Only: false,
            searchInNewCreationsOnly: false,
            searchInItemsWithGratuitiesOnly: false,
            searchInItemsWithControlledSalesOnly: false,
            searchPharmaOnly: false,
            searchParaOnly: false,
            paginationOptions: [5,10,15,30],
            allItemsPaginationOptions: [5,10,15,30],
        }
    }, 
    methods:{


        syncItemsNow() {


            Swal.fire({
                title: i18n.t('ItemSync.swal.title'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                cancelButtonText: i18n.t('ItemSync.swal.cancelButtonText'),
                confirmButtonText: i18n.t('ItemSync.swal.confirmButtonText'),
            }).then((result) => {
                if (result.value) {
                    ItemsApi.syncItems().then((result)=>{
                        if (result) {
                            Vue.prototype.$snotify.success("La synchronisation des articles est lancée");
                        }
                    })
                }
            });


        },

        findItems(){
            this.findItemsByReference(); 
        },
        
        resetPagination(){
            this.pagemodel.currentPage = 1;
        },
        resetBlackPagination(){
            this.pagemodelBlack.currentPage = 1;
        },
        findBlackListItems() {
            this.isBlackListTableLoading = true;
            this.itemsListTimestamp = new Date().getTime();
            BlockItemsApi.getBlockedList(this.pagemodelBlack.currentPage, this.pagemodelBlack.perPage,this.itemsListTimestamp)
            .then(itemsList => {

                if(itemsList){

                

                    this.itemsBlackList = itemsList.list
                    this.pagemodelBlack.totalRows = itemsList.total;
                    this.pagemodelBlack.currentPage = itemsList.page;
                    this.pagemodelBlack.perPage = itemsList.pageSize;
                    this.pagemodelBlack.pageSize = itemsList.pageSize;
                    this.itemsBlackList.forEach(function(item){
                        item.quantity = 1;
                    });   
                            
                } else {

                    this.itemsBlackList = []
                    this.pagemodelBlack.totalRows = 0;
                    this.pagemodelBlack.currentPage = 1;
                    this.pagemodelBlack.perPage = this.paginationOptions[0];
                    this.pagemodelBlack.pageSize = this.paginationOptions[0];

                }
            })
            .finally(() => {
                this.isBlackListTableLoading = false;
            });
        },

        findItemsByReference() {
            this.isTableLoading = true;
            this.itemsListTimestamp = new Date().getTime();
            ItemsApi.findItems(this.pagemodel.currentPage, this.pagemodel.perPage, this.selectedBrandsList == null ? null : this.selectedBrandsList, this.reference, 
                    this.selectedGroup == null ? null : this.selectedGroup.id, 
                    this.selectedSubGroup == null ? null : this.selectedSubGroup.id, 
                    this.filterItemAvailable == null ? null : this.filterItemAvailable, 
                    this.filterItemHasImage == null ? null : this.filterItemHasImage,
                    this.filterItemHasDescription == null ? null : this.filterItemHasDescription,
                    !this.filterItemHasDescription == null || !this.filterDescription ? null : this.filterDescription,
                    this.filterPriceMin == null ? null : this.filterPriceMin,
                    this.filterPriceMax == null ? null : this.filterPriceMax,
                    

                    this.selectedItemForm == null ? null : this.selectedItemForm.id,
                    this.selectedDci == null ? null : this.selectedDci.id ,

                    this.searchInNewItemsOnly == null ? null : this.searchInNewItemsOnly,
                    this.searchInNewItemsLast24Only == null ? null : this.searchInNewItemsLast24Only,
                    
                    this.searchInNewCreationsOnly == null ? null : this.searchInNewCreationsOnly,
                    this.searchInItemsWithGratuitiesOnly == null ? null : this.searchInItemsWithGratuitiesOnly,
                    this.searchInItemsWithControlledSalesOnly == null ? null : this.searchInItemsWithControlledSalesOnly,

                    this.searchParaOnly == null ? null : this.searchParaOnly,
                    this.searchPharmaOnly == null ? null : this.searchPharmaOnly,

                    this.itemsListTimestamp

                    )

            .then(itemsList => {

                if(itemsList){

                    

                    this.itemsList = itemsList.list
                    this.pagemodel.totalRows = itemsList.total;
                    this.pagemodel.currentPage = itemsList.page;
                    this.pagemodel.perPage = itemsList.pageSize;
                    this.pagemodel.pageSize = itemsList.pageSize;
                    
                            
                } else {

                    this.itemsList = []
                    this.pagemodel.totalRows = 0;
                    this.pagemodel.currentPage = 1;
                    this.pagemodel.perPage = this.allItemsPaginationOptions[0];
                    this.pagemodel.pageSize = this.allItemsPaginationOptions[0];

                }
            })
            .finally(() => {
                this.isTableLoading = false;
            });
        },
    
        activerArticle(item) {
            Swal.fire({
                title: i18n.t('itemTabs.swal.activerArticle.title'),
                html: item.title,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                cancelButtonText: i18n.t('itemTabs.swal.activerArticle.cancelButtonText'),
                confirmButtonText: i18n.t('itemTabs.swal.activerArticle.confirmButtonText'),
            }).then((result) => {
                if (result.value) {
                    BlockItemsApi.deleteItemFromBlackList(item.ref).then(itemsList => {

                        if(itemsList){



                            this.itemsBlackList = itemsList.list
                            this.pagemodelBlack.totalRows = itemsList.total;
                            this.pagemodelBlack.currentPage = itemsList.page;
                            this.pagemodelBlack.perPage = itemsList.pageSize;
                            this.pagemodelBlack.pageSize = itemsList.pageSize;
                            this.itemsBlackList.forEach(function(item){
                                item.quantity = 1;
                            });   
                                    
                        } 
                });
                }
            });
        },
        blockItem(item) {
            Swal.fire({
                title: i18n.t('itemTabs.swal.blockItem.title'),
                html: item.title,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#34c38f",
                cancelButtonText: i18n.t('itemTabs.swal.blockItem.cancelButtonText'),
                confirmButtonText: i18n.t('itemTabs.swal.blockItem.confirmButtonText'),
            }).then((result) => {
                if (result.value) {
                    BlockItemsApi.addItemToBlackList(item.id).then(itemsList => {

                        if(itemsList){



                            this.itemsBlackList = itemsList.list
                            this.pagemodelBlack.totalRows = itemsList.total;
                            this.pagemodelBlack.currentPage = itemsList.page;
                            this.pagemodelBlack.perPage = itemsList.pageSize;
                            this.pagemodelBlack.pageSize = itemsList.pageSize;
                            this.itemsBlackList.forEach(function(item){
                                item.quantity = 1;
                            });   
                                    
                        } 

                });
                }
            });
        },
    },
}
</script>
<template>
        <div class="row  p-4">
            <div class=" card col-lg-7 pr-2 border border-danger"  >
                <div class=" card-body">
                    <h2 class="card-title font-size-25 text-danger " style="font-size:2em;">Liste des articles bloqués</h2>
                    <div class="row " style="height:  6vh;" > </div>

                    <!-- BlackListTable -->
                    
                    <div class="table-responsive pt-4 pr-4 pl-4 "  > 
                        <b-table
                            :busy="isBlackListTableLoading"
                            :items="itemsBlackList"
                            :fields="blockedItemsListFields"
                            :perPage="pagemodelBlack.perPage"
                            class="table  "
                            selectable
                            select-mode="single"
                            selected-variant="primary"
                            >
                            <template v-slot:head(ref)>
                                {{ $t("catalog.header.reference") }} 
                            </template>
                            <template v-slot:head(title)>
                                {{ $t("catalog.header.title") }} 
                            </template>
                            
                            <template v-slot:table-busy>
                                <div class="text-center my-2">
                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                </div>
                            </template>
                            
                            <template v-slot:cell(ref)="{item}">
                                <span class="text-danger font-size-12 font-weight-bold">{{item.ref }}  </span>
                            </template>

                            <template v-slot:cell(title)="{item}">
                                <span class=" font-size-12 font-weight-bold" >{{item.title }} </span>
                            </template>

                            <template  v-slot:cell(action)="{item}">
                                <a  href="javascript:void(0);" @click="activerArticle(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-success ">
                                    <i  class="mdi mdi-trash-can font-size-16 "></i><span class="text-center font-size-14 ml-2">Débloquer l'article</span>
                                </a>
                            </template>
                        </b-table>
                        <span v-if="!isBlackListTableLoading && !itemsBlackList.length" class="d-flex justify-content-center mr-4 ml-4 mt-4 mb-4 text-danger" >{{ $t("itemTabs.empty") }} </span>
                    </div>
                    <!-- Pagination -->
                    <div v-if="!isBlackListTableLoading" class="row pt-2 pb-4 pr-4 pl-4 ">
                        <div class="col-sm-8">
                            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                <b-form-select @input="findBlackListItems()"  v-model="pagemodelBlack.perPage" size="sm" style="width: 5em" :options="[5, 10, 50, 100]"></b-form-select>
                                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodelBlack.totalRows}} {{ $t("pagination.lines") }}</span></div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="pagemodelBlack.currentPage" :per-page="pagemodelBlack.pageSize" :total-rows="pagemodelBlack.totalRows" @input="findBlackListItems()" :disabled="isTableLoading" ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <!-- Fin Pagination  -->
                </div>
            </div>
       
            <div class="col-lg-5 pl-4 text-left">
                <div >
              
                    <div class="card-body p-0">
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <h2 class="card-title font-size-18 pt-2 pb-4 " style="font-size:2em;"> LISTE DES ARTICLES</h2>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="float-right mb-3">
                                    <b-button  title="Sync" size="md"   variant="outline-danger"  @click.prevent="syncItemsNow()"  >
                                        <i class="fas fa-sync-alt  font-size-16  font-weight-bold align-middle  mr-0 mr-sm-2"></i>
                                        <span class=" font-weight-bold text-uppercase d-none d-sm-inline">Forcer la Sync des Articles</span>         
                                    </b-button> 
                                </div>  
                            </div>
                        </div>
                        <div class="row">
                            
                            <div class="col-12  pb-4">
                    
                                    

                                    <div class="col-12">
                                    <b-input-group>
                                        <b-form-input id="reference-search-input" v-model="reference" placeholder="Réf ou désignation" @keyup.native.enter="resetPagination();findItems();"
                                        class="text-dark font-weight-bold font-size-14  "
                                        ></b-form-input>
                                        <template v-slot:append>
                                            <b-button class="ml-2" size="sm" variant="success" @click="resetPagination();findItems();">
                                            <span class="font-weight-bold"> <i class="bx bx-search-alt font-weight-bold font-size-16 pr-1 pl-1 text-white align-middle"/>  </span> 
                                            </b-button>
                                        </template>                            
                                    </b-input-group>
                                    </div>

                            </div>
                         
                            <div class="col-12 ">
                          
                             
                                    <div class="table-responsive pt-2"> 
                                        <b-table
                                            :busy="isTableLoading"
                                            :items="itemsList"
                                            :fields="itemsListFields"
                                            :perPage="pagemodel.perPage"
                                            class="table  "
                                            
                                            select-mode="single"
                                            selected-variant="primary"
                                            >
                                            <template v-slot:head(ref)>
                                                {{ $t("catalog.header.reference") }} 
                                            </template>
                                            <template v-slot:head(title)>
                                                {{ $t("catalog.header.title") }} 
                                            </template>
                                            
                                            <template v-slot:table-busy>
                                                <div class="text-center my-2">
                                                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                                                </div>
                                            </template>
                                        
                                            <template v-slot:cell(ref)="{item}">
                                                <span class="text-dark font-size-12 font-weight-bold">{{item.ref }}  </span>
                                            </template>

                                            <template v-slot:cell(title)="{item}">
                                                <span class=" font-size-12 font-weight-bold" >{{item.title }} </span>
                                            </template>

                                            <template  v-slot:cell(action)="{item}">
                                                <a  href="javascript:void(0);" @click="blockItem(item)" class="action-icon text-danger">                                             
                                                    <i  class="fas fa-ban  font-size-14 "></i><span class="text-center font-size-14 ml-2">Bloquer</span>
                                                </a>
                                            </template>
                                        </b-table>
                                        <span v-if="!isTableLoading && !itemsList.length" class="d-flex justify-content-center mr-4 ml-4 mt-4 mb-4 text-danger" >{{ $t("itemTabs.empty") }} </span>
                                    </div>
                                    <!-- Pagination -->
                                    <div v-if="!isTableLoading" class="row pt-3 pl-2 mb-sm-4">
                                        <div class="col-sm-8">
                                            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                                <b-form-select @input="findItems()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[5, 10, 50, 100]"></b-form-select>
                                                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                                <ul class="pagination pagination-rounded mb-0">
                                                <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findItems()" :disabled="isTableLoading" ></b-pagination>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> 
                                    <!-- Fin Pagination  -->

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
</template>